import { render, staticRenderFns } from "./FacebookChannel.vue?vue&type=template&id=4f66bc62&"
import script from "./FacebookChannel.vue?vue&type=script&lang=js&"
export * from "./FacebookChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports